import { Navigate, useParams } from 'react-router-dom';
import Hero from '../../components/pages/MarketAnalysisDetails/Hero/Hero';
import Content from '../../components/pages/MarketAnalysisDetails/Content/Content';
import FromTheBlog from '../../components/pages/MarketAnalysisDetails/FromTheBlog/FromTheBlog';
import Join from '../../components/pages/MarketAnalysisDetails/Join/Join';
import { useMarketAnalysisPost } from '../../hooks/useMarketAnalysisPost';

const MarketAnalysisDetails = () => {
  const { slug } = useParams();
  const { post, isLoading } = useMarketAnalysisPost(slug);

  if (isLoading) {
    return null;
  }

  if (!post) {
    return <Navigate to="/insights/market-analysis" replace />;
  }

  return (
    <div>
      <Hero
        category={post.category}
        title={post.title}
        excerpt={post.excerpt}
        image={post.image}
      />
      <Content post={post} />
      <FromTheBlog currentSlug={post.slug} />
      <Join />
    </div>
  );
};

export default MarketAnalysisDetails;
